// Copyright (c) 2016 Deere & Company

import './mass-channel-customer-follow-up-report.scss';
import React, {
    Component,
    PropTypes
} from 'react';
import Dealer from '@deere/cps-it.warranty-model-factory/lib/dealer';
import FavoriteIcon from '../../../shared/components/favorites/favorite-icon';
import {FormattedMessage} from 'react-intl';
import Formatting from '../state/formatting';
import GeneralSettings from '@deere/cps-it.warranty-model-factory/lib/general-settings';
import InlineAlertBar from '../../../shared/components/inline-alert-bar/index';
import MassChannelCustomerFollowUp from '@deere/cps-it.warranty-model-factory/lib/mass-channel-customer-follow-up';
import MassChannelCustomerFollowUpReportCriteria from './mass-channel-customer-follow-up-report-criteria';
import NumberOfRecordsFound from '../../../shared/components/number-of-records-found/index';
import ReportGrid from '../../shared/components/report-grid';
import ReportHeader from '../../shared/components/report-header';
import ReportHiddenColumns from '../../shared/components/report-columns';
import ReportLayout from '@deere/cps-it.warranty-model-factory/lib/report-layout';
import ShowNoResultsFound from '../../shared/components/show-no-results-found/show-no-results-found';
import View from '../state/view';
import WarrantyAgGridDatePicker from '../../shared/components/ag-grid-date-picker';
import WarrantyLoadingIndicator from '../../../shared/components/warranty-loading-indicator';
import {exportToCSV} from '../../../reports/shared/services/export-to-csv';
import {getAgGridLocaleText} from '../../../shared/utils/ag-grid-locale-text';
import {getDefaultReportLayout} from '../../shared/services/report-variant';
import {getMassChannelColumnDefinitions} from '../report-services/column-definitions';
import {scrollToAndResizeReport} from '../../shared/services/scroll-window';

function handleDealerSelect(index, isSelected) {

    this.actions.selectMassChannelCustomerFollowupDealer(index, isSelected);

}

function handleCreateReport() {

    this.actions.toggleReportIsScrollable();
    this.actions.resetSearchResults();
    this.actions.createMassChannelCustomerFollowUpReport();

}

function handleToggleDealers() {

    this.actions.selectAllMassChannelCustomerFollowupDealers(this.selectedAccounts);

}

function handleGridApiDefinition(params) {

    let defaultColumnState,
        defaultSortModel;

    this.actions.createAgGridApi(params.api, params.columnApi);

    if (this.selectedLayout && this.selectedLayout.name && !this.isInitialLoad) {

        const defaultLayout = this.layouts.find(layout => !layout.name);

        defaultColumnState = defaultLayout.columnState;
        defaultSortModel = defaultLayout.sortModel;

    } else {

        defaultColumnState = params.columnApi.getColumnState();
        defaultSortModel = params.api.getSortModel();

        this.actions.updateReportProperty('isInitialLoad', false);

    }

    this.actions.updateDefaultLayout(defaultColumnState, defaultSortModel);

    if (this.selectedLayout && this.selectedLayout.name) {

        params.columnApi.setColumnState(this.selectedLayout.columnState);
        params.api.setSortModel(this.selectedLayout.sortModel);
        params.api.setFilterModel(this.selectedLayout.filterModel);

    } else {

        const defaultLayout = getDefaultReportLayout(defaultColumnState, defaultSortModel);

        this.actions.updateReportProperty('selectedLayout', defaultLayout);

    }

}

function onColumnRemoved(columnEvent) {

    if (!columnEvent.visible) {

        this.actions.hideReportColumn(this.columnApi.getColumnState());

    }

}

function handleExportToCsv() {

    const fileName = 'mass-channel';

    return exportToCSV(fileName, this.gridApi);

}

function handleReset() {

    this.actions.selectAllDealersOnLoad(this.selectedAccounts);
    this.actions.resetSearchResults();
    this.actions.updateShowNoResultsFound(false);

}

class MassChannelCustomerFollowUpReport extends Component {

    componentWillMount() {

        this.props.actions.selectAllDealersOnLoad(this.props.selectedAccounts);
        this.props.actions.getReportLayouts('mass-channel-customer-followup');
        this.props.actions.updateGridLayouts(this.props.layouts, getMassChannelColumnDefinitions());

    }

    componentDidUpdate(prevProps) {

        if (this.props.reportIsScrollable && this.props.report.length) {

            this.props.actions.resetReportIsScrollable();

            scrollToAndResizeReport();

        }

        const isFirstRun = !prevProps.report.length && !prevProps.showNoResultsFound;
        const layoutWasChanged = this.props.selectedLayout !== prevProps.selectedLayout;
        const readyToApplyLayout = this.props.selectedLayout && Object.keys(this.props.columnApi).length && this.props.isDefaultColumnStateAvailable;

        if ((isFirstRun || layoutWasChanged) && readyToApplyLayout) {

            this.props.columnApi.setColumnState(this.props.selectedLayout.columnState);
            this.props.gridApi.setSortModel(this.props.selectedLayout.sortModel);
            this.props.gridApi.setFilterModel(this.props.selectedLayout.filterModel);

        }

    }

    componentWillUnmount() {

        this.props.actions.resetSearchResults();
        this.props.actions.updateShowNoResultsFound(false);
        this.props.actions.resetReportVariant();

    }

    render() {

        const gridOptions = {
            dateComponentFramework: WarrantyAgGridDatePicker
        };

        return (
            <section className='mass-channel-customer-follow-up'>
                <WarrantyLoadingIndicator isLoading={this.props.busyCounter > 0}/>
                <h2 className='mass-channel-customer-follow-up-title'>
                    <FormattedMessage id='MASS_CHANNEL_CUSTOMER_FOLLOW_UP'/>
                    <FavoriteIcon
                        id='MASS_CHANNEL_CUSTOMER_FOLLOW_UP'
                        route={this.props.pathName}
                    />
                </h2>
                <MassChannelCustomerFollowUpReportCriteria
                    allowedAccounts={this.props.selectedAccounts}
                    canExport={this.props.report.length > 0}
                    canRunReport={this.props.selectedDealers.length > 0}
                    onCreateReport={this.props::handleCreateReport}
                    onDealerSelect={this.props::handleDealerSelect}
                    onExportToCsv={this.props::handleExportToCsv}
                    onReset={this.props::handleReset}
                    onSelectAllDealers={this.props::handleToggleDealers}
                    selectedDealers={this.props.selectedDealers}
                />
                {this.props.report.length ?
                    <div>
                        <NumberOfRecordsFound count={this.props.report.length}/>
                        <InlineAlertBar label='MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT'/>
                        {this.props.isReportColumnsVisible && <ReportHiddenColumns/>}
                        <section className='report'>
                            <ReportHeader
                                columnApi={this.props.columnApi}
                                gridApi={this.props.gridApi}
                                reportName='mass-channel-customer-followup'
                            />
                            <ReportGrid
                                columnDefs={getMassChannelColumnDefinitions()}
                                gridOptions={gridOptions}
                                localeText={getAgGridLocaleText()}
                                onColumnVisible={this.props::onColumnRemoved}
                                onGridReady={this.props::handleGridApiDefinition}
                                rowData={this.props.report}
                            />
                        </section>
                    </div> :
                    <ShowNoResultsFound showNoResultsFound={this.props.showNoResultsFound}/>
                }
            </section>
        );

    }

}

MassChannelCustomerFollowUpReport.displayName = 'MassChannelCustomerFollowUpReport';
MassChannelCustomerFollowUpReport.propTypes = {
    actions: PropTypes.object.isRequired,
    busyCounter: PropTypes.number.isRequired,
    columnApi: PropTypes.object.isRequired,
    formatting: PropTypes.instanceOf(Formatting).isRequired,
    generalSettings: PropTypes.instanceOf(GeneralSettings).isRequired,
    gridApi: PropTypes.object.isRequired,
    isDefaultColumnStateAvailable: PropTypes.bool.isRequired,
    isInitialLoad: PropTypes.bool.isRequired,
    isReportColumnsVisible: PropTypes.bool.isRequired,
    layouts: PropTypes.arrayOf(PropTypes.instanceOf(ReportLayout)).isRequired,
    pathName: PropTypes.string.isRequired,
    report: PropTypes.arrayOf(PropTypes.instanceOf(MassChannelCustomerFollowUp)),
    reportIsScrollable: PropTypes.bool.isRequired,
    selectedAccounts: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedDealers: PropTypes.arrayOf(PropTypes.instanceOf(Dealer)).isRequired,
    selectedLayout: PropTypes.instanceOf(ReportLayout),
    showNoResultsFound: PropTypes.bool.isRequired,
    views: PropTypes.arrayOf(PropTypes.instanceOf(View)).isRequired
};

export default MassChannelCustomerFollowUpReport;



// WEBPACK FOOTER //
// ./src/reports/mass-channel-customer-follow-up/components/mass-channel-customer-follow-up-report.js